// extracted by mini-css-extract-plugin
export var typingIndicator = "_r7-0";